import {
  httpDictServ,
} from '@/services'
import {fileConfirm} from '@/utils/file'
import {message} from 'antd'
import dayjs from 'dayjs'
import {httpCompanyList} from "@/services/homeService.ts";
import {achievementChannelTypePage} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";

/**
 * 获取数据字典并复制给Ref
 * @param category - 目录Ref
 * @returns {Promise}
 */
export const getCategoryFn = (category: { current: any }): Promise<any> => {
  return new Promise(async resolve => {
    const resData: any = await httpDictServ({ parentKey: 'performanceType', enable: 1 })
    category.current = resData
    resolve(resData)
  })
}

/** 获取分公司列表 */
export const getCompanyFn = (compony: { current: any }): Promise<any> => {
  return new Promise(async resolve => {
    const companyList: any = await httpCompanyList()
    const companyTree: any[] = [{ title: '全部分公司', val: [], key: '0-0', child: [] }]
    if (companyList.length) {
      for (let i = 0; i < companyList.length; i++) {
        companyList[i].title = companyList[i].name
        companyList[i].val = companyList[i].id + ''
        companyList[i].key = companyList[i].val
        companyTree[0].val.push(companyList[i].val)
        companyTree[0].child.push(companyList[i])
      }
    }
    compony.current = companyTree
    resolve(companyTree)
  })
}

/**
 * 导出
 * @param {object} values - 导出需要传递的参数
 */
export const onExportFn = (values: { [key: string]: any }) => {
  console.log('ht...')
  const {  yearMonth, category } = values
  const params =
    '?yearMonth=' +
    (yearMonth ? yearMonth : '') +
    '&category=' +
    (category ? category : '') 
  message.loading({ content: '导出中' })
  // HttpAchievementMilitaryExport(params)
  //   .then((res: any) => {
  //     fileConfirm()
  //   })
  //   .catch(error => {
  //     console.log(error)
  //   })
}

/**
 * 表格统一请求
 * @param values - 表单数据
 * @returns
 */
export const fetchList = (values: any) => {
  return new Promise((resolve, reject) => {
    try {
      const { current, pageSize, query } = values
      const newObj = {
        ...query,
        year: query.year ? dayjs(query.year).format('YYYY') : undefined,
        month: query.month ? dayjs(query.month).format('MM') : undefined,
      }
      achievementChannelTypePage({params: {pageId: current, pageSize}, data: newObj}).then(data => resolve(apiData2Table(data)))
    } catch {
      reject({ success: false })
    }
  })
}
